import {Controller} from "./helpers/controller";

/**
 * @description Create tabbed navigation in an accessible way.
 * @constructor new Splendid.TabbedContent(); and pass through the object literal with options
 * @requires jQuery
 *
 * @namespace
 * @property {string} targetDiv - ID of element that holds the tabs and/or tabbed content
 * @property {string} tabSelectedClass - The class for the selected state of the tab
 * @property {object} content - Array of IDs of the divs you wish to hide, first item is given the selected state (so is visible)
 * @property {string} targetTab - The tab you would like as the start tab - selected class is added to this tab
 * @property {string} selectedDiv - ID of the content to show on load, overrides the default first item in the content array
 *
 *       Usage:
 *       HTML The ID in the HREF Must match the id of the content div's to work
 *        <ul id="tabbedContent">
 *		 	<li id="tabOne"><a href="#areaGuide">The D&amp;G area guides</a></li> // In the HTML <a> is an anchor to the div
 *			<li id="tabTwo"><a href="#ourOffices">Where are our offices?</a></li>
 *			<li id="tabThree"><a href="#weCover">The area we cover</a></li>
 *		</ul>
 *       <div id="areaGuide">
 *       	Tab 1 content
 *       </div>
 */
/// <reference path="../lib/jquery.d.ts" />

interface ITabbedContent {
    tabSelectedClass: string;
   selectedDiv: string;
    callback: Function
}

export class TabControl extends Controller {
    private readonly content: Array<string> = [];
    private targetTab: HTMLElement = $(this._element).children()[0];
    private selectedDiv: HTMLElement = this.targetTab;
   private settings: ITabbedContent = {
        tabSelectedClass: 'selected', // default class name for the selected tab
        selectedDiv: '',
       callback: () => { }
    };

    constructor(element:HTMLElement, options?: ITabbedContent) {
        super(element);
        let _this = this;
        if (options) {
            $.extend(this.settings, options); // Overwrites the default settings with those defined in the function call (options object)
        }

        this.content = $.map($(element).find("[role=tab] a"), function(n, i){
            return _this.getTheElementToShow(n.href);
        });
        
        if (this.settings.selectedDiv.length > 0){
            this.selectedDiv = document.getElementById(this.settings.selectedDiv) as HTMLElement;
        } else{
            this.selectedDiv = $(this.content[0]).get()[0];
        }
        
        this.hideContent(this.settings);
        this.initialView(this.settings);
        this.addClickEvents(this.settings);
    }

    hideContent(settings: ITabbedContent) {
        var numberOfTabbedContent = this.content.length;
        for (var count = 0; count < numberOfTabbedContent; count++) {
            $(this.content[count]).hide();
        }
    }

    initialView(settings: ITabbedContent) {
        $(this.targetTab).addClass(settings.tabSelectedClass);

        $(this.selectedDiv).show();
    }

    addClickEvents(settings: ITabbedContent) {
        var clickableElements = this._element.getElementsByTagName('a');
        var numberOfClickableElements = clickableElements.length;
        for (var count = 0; count < numberOfClickableElements; count++) {
            clickableElements[count].addEventListener('click', this.handleClickEvent);
        }
    }

    getTheElementToShow(fullURL:string) {
        var theURL = '[\\#]([^&#]*)';
        var regex = new RegExp(theURL);
        var tabHrefID = regex.exec(fullURL);
        return tabHrefID == null ? '' : tabHrefID[0];
    }

    showHideContentEvent(elementToShow:string, tabClicked:HTMLElement, settings:ITabbedContent) {
        if (elementToShow != this.selectedDiv.id) {
            // Displays the content
            $(this.selectedDiv).hide();
            $(elementToShow).show();
            this.selectedDiv = $(elementToShow).get()[0] as HTMLElement;

            // Changes the class on the tabs
            $(this.targetTab).removeClass(settings.tabSelectedClass);
            $(tabClicked).addClass(settings.tabSelectedClass);
            this.targetTab = tabClicked;
            
        }
    }

    handleClickEvent = (element: any) => {
        var parentElementClicked = element.target.parentNode as HTMLElement;
        var divToShow = this.getTheElementToShow(element.target.href); // Returns the ID from the URL
        this.showHideContentEvent(divToShow, parentElementClicked, this.settings);

        element.preventDefault();
        
        this.settings.callback();
    };
}
